import React from "react";
import styled from "styled-components";
import Color from "../../../assets/Colors";
import {Link} from "react-router-dom";
import {ButtonSubmit, InputForm} from "../../../components/footer/styles";

export const ContentAuth = styled.div`
   width: 100%;
   display: flex;
   justify-content: ${props => props.justify || "center"};
   flex-direction: ${props => props.direction || "row"};
   align-items: center;
   padding: 0;
   padding: 3em 0;
   padding-top: 7em;

   @media screen and (max-width: 1600px) {
      padding: 1em 0;
      padding-top: 8em;
   }

   @media screen and (max-width: 500px) {
      padding-top: 3em;

      &:first-child {
         padding-top: 5em;
         // background: red;
      }
   }
`;
export const CardAuth = styled.div`
   display: flex;
   justify-content: ${props => props.justify || "center"};
   align-items: ${props => props.align || "center"};
   flex-direction: column;
   padding: ${props => props.padding};

   & .head {
      width: 100%;
   }

   & .styleCardContact {
      margin-top: 80px;
   }
`;
export const CardOptions = styled.div`
   display: flex;
   justify-content: center;
   flex-direction: column;
   align-items: center;
   width: 30vw;
   padding: 1em 0;

   @media screen and (max-width: 1600px) {
      width: 32vw;
   }
   @media screen and (max-width: 500px) {
      width: 100%;
   }
`;

export const TitleAuth = styled.p`
   font-size: 1.67em;
   font-weight: 200;
   color: ${props => props.color || Color.primary};
   margin-bottom: 1em;

   @media screen and (max-width: 1600px) {
      font-size: 1.4em;
   }

   @media screen and (max-width: 500px) {
      font-size: 1.2em;
   }
`;
export const TextAuth = styled.div`
   font-size: 1.2em;
   font-weight: 200;
   color: ${props => props.color || Color.textColor};
   text-transform: ${props => props.transform || ""};

   @media screen and (max-width: 1600px) {
      font-size: 0.8em;
   }
   @media screen and (max-width: 800px) {
      font-size: 0.9em;
   }
`;

export const SubtitleAuth = styled(TextAuth)`
   font-size: 1.2em;
   margin-bottom: 1em;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`;

export const TextLink = styled(Link)`
   display: inline-block;
   font-size: 1.2em;
   font-weight: 400;
   color: ${props => props.color || Color.primary};
   padding-bottom: ${props => props.paddBtn || "0.5em"};
   border-bottom: ${props => props.visibleborder || `1px solid ${Color.primary}`};
   user-select: none;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }

   &.thin {
      font-weight: 200;
   }
`;

export const LabelLinks = styled(Link)`
   font-size: 1em;
   font-weight: 200;
   color: ${props => props.color || Color.textColor};
   user-select: none;
   text-decoration: ${props => props.decoration || "underline"};

   white-space: wrap;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`;

export const ButtonOption = styled(ButtonSubmit)`
   color: ${props => props.color || Color.primary};
   border: 1px solid ${props => props.color || Color.primary};
   padding: 0.9em;
   font-size: 1em;
   min-width: 320px;
   max-width: 360px;
   font-weight: 200;
   user-select: none;

   &:not(:last-child) {
      margin-bottom: 2em;
   }

   display: flex;
   justify-content: center;
   align-items: center;
   text-transform: uppercase;

   &.widthAuto {
      padding-left: 2em;
      padding-right: 2em;
      min-width: auto;
      max-width: auto;
   }

   & .icon {
      margin-right: 0.5em;
      fill: ${props => props.color || Color.primary};
      width: 1.8em;
      height: 1.8em;
   }

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
      & .icon {
         margin-right: 0.8em;
         width: 1.4em;
         height: 1.4em;
      }
   }
`;

export const OrOption = styled.div`
   width: 100%;
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin: 1.5em 0;

   & > span.text {
      margin: 0 0.5em;
      color: ${Color.textColor};
   }

   & > span.line {
      border-bottom: 1px solid ${Color.textColor};
      width: 80%;
      height: 1px;
   }
`;

export const ContainerButtons = styled.div`
   width: 100%;
   display: flex;
   flex-direction: column;
   justify-content: ${props => props.justify || "center"};
   align-items: ${props => props.align || "center"};
   margin: 0 auto;
   margin-top: 2em;

   & button {
      width: ${props => props.width || "70%"};

      &.widthAuto {
         width: auto;
         min-width: auto;
         max-width: auto;
      }
   }

   &.recover {
      padding: 0.5em;

      & button {
         width: 100%;
         color: white;
         background: ${Color.primary};
      }
   }
`;

export const InputAuth = styled(InputForm)`
   border-bottom: 1px solid ${Color.textColor};
   width: 100%;
   transition: all 420ms ease;
   margin-top: 1em;

   &.error {
      border-bottom-color: crimson;
      transition: all 420ms ease;
   }
`;

export const FormAuth = styled.form`
   width: 100%;
`;

export const MoreForm = styled.div`
   width: 100%;
   margin-top: 1.5em;
   display: flex;
   justify-content: space-between;
`;

export const LabelAuth = styled.label`
   font-size: 0.9em;
   outline: none;
   border: none;
   padding: 0.5em;
   color: grey;
   background: transparent;
   font-weight: 200;
   // font-weight: 400;
   // color: ${Color.primary};
   margin ${props => props.margin || "0"};

   @media screen and (max-width: 500px) {
      width: 100%;
   }
`;

export const CheckInput = styled.input`
   display: none;

   & + label {
      display: inline-flex;
      align-items: center;

      & .checkBox {
         width: 1em;
         height: 1em;
         display: inline-flex;
         align-items: center;
         justify-content: center;

         margin-right: 0.5em;
         border-radius: 50%;
         border: 1px solid rgba(214, 196, 152, 1);

         transition: all 420ms;

         & .tick {
            width: 0.6em;
            height: 0.6em;
            fill: ${Color.secondary};
            opacity: 0;
         }
      }
   }

   &:checked {
      & + label {
         & .checkBox {
            background: rgba(214, 196, 152, 0.2);
            transition: all 420ms;

            & .tick {
               opacity: 1;
            }
         }
      }
   }
`;

export const BodyForm = styled.div`
   display: flex;
   flex-direction: column;
   margin-top: 2em;
`;

export const MultiComponent = styled.div`
   display: flex;
   justify-content: flex-start;
   align-items: center;

   margin: ${props => props.margin || "1em 0 0 0"};

   & .labelCheck {
      margin-right: 1em;
   }
   & .line {
      border-right: 1px solid ${Color.textColor};
      display: block;
      height: 1.5em;
      margin: 0 1em;
      margin-top: 1em;
   }

   & .inputMin {
      width: 4.3em;
      &.year {
         width: 5em;
      }
   }

   @media screen and (max-width: 1600px) {
      & .inputMin {
         width: 3em;
         &.year {
            width: 3.5em;
         }
      }
   }

   @media screen and (max-width: 500px) {
      flex-wrap: wrap;
   }
`;

export const SectionSeparator = styled.div`
   width: 100%;
   margin: 1em 0 2.8em 0;
   border-bottom: 0.8px solid ${Color.textColor};

   @media screen and (max-width: 800px) {
      margin: 1em 0 0em 0;
   }

   @media screen and (max-width: 500px) {
      margin: 1.5em 0;
   }
`;

export function OrComponent() {
   return (
      <OrOption>
         <span className="line"></span>
         <span className="text">O</span>
         <span className="line"></span>
      </OrOption>
   );
}
